<div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
        <!-- Login v1 -->
        <div class="card mb-0">
            <div class="card-body">
                <a href="javascript:void(0);" class="brand-logo">
                    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
                    <h2 class="brand-text text-primary ml-1">EUROED</h2>
                </a>

                <h4 class="card-title mb-1">Bem-vindo de volta! 👋</h4>
                <p class="card-text mb-2">Estimado cliente, por-favor inicie sessão para continuar</p>

                <form class="auth-login-form mt-2" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label for="login-email" class="form-label">Email</label>
                        <input type="text" formControlName="email" class="form-control" placeholder="john@example.com" aria-describedby="login-email" tabindex="1" autofocus [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email é obrigatório</div>
                            <div *ngIf="f.email.errors.email">Email deve ser válido</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label for="login-password">Password</label>
                        </div>
                        <div class="input-group input-group-merge form-password-toggle">
                            <input [type]="passwordTextType ? 'text' : 'password'" formControlName="password" class="form-control form-control-merge" tabindex="2" placeholder="·········" aria-describedby="login-password" [ngClass]="{ 'is-invalid error': submitted && f.password.errors }"
                            />

                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer"><i
                  class="feather font-small-4"
                  [ngClass]="{
                    'icon-eye-off': passwordTextType,
                    'icon-eye': !passwordTextType
                  }"
                  (click)="togglePasswordTextType()"
                ></i
              ></span>
                            </div>
                        </div>
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && f.password.errors }">
                            <div *ngIf="f.password.errors.required">Password é obrigatória</div>
                        </div>
                    </div>
                    <button class="btn btn-primary btn-block" tabindex="3" rippleEffect>Entrar</button>
                </form>

                <p class="text-center mt-2">
                    <span>Esqueceu-se?</span>
                    <a href="tel: +351 249 870 716">
                        <span>&nbsp;Ligue-nos +351 249 870 716</span>
                    </a>
                </p>
            </div>
        </div>
        <!-- /Login v1 -->
    </div>
</div>